/** @format */

import { CommonModule } from '@angular/common';
import { DateAgoPipe } from './date-ago.pipe';
import { NgModule } from '@angular/core';
import { SplitContentPipe } from './split-content.pipe';
import { StarRatingNumberPipe } from './star-rating-number.pipe';

@NgModule({
	imports: [CommonModule],
	declarations: [DateAgoPipe, SplitContentPipe, StarRatingNumberPipe],
	exports: [DateAgoPipe, SplitContentPipe, StarRatingNumberPipe]
})
export class ProductReviewsPipesModule {}
